import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  showHeaderAndFooter = true;

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showHeaderAndFooter = !this.shouldHideHeaderAndFooter(event.url);
      }
    });
  }

  ngOnInit(): void { }

  private shouldHideHeaderAndFooter(url: string): boolean {
    const hiddenRoutes = [
      '/signup-basic',
      '/signup-religion',
      '/signup-personal',
      '/signup-professional',
      '/login',
      '/rm/login'
    ];
    const path = url.split('?')[0].replace('/#', '');
    if (path.startsWith('/merchant') || path.startsWith('/admin') || path.startsWith('/broker') || path.startsWith('/rm') || path.includes('/rm/') || path.includes('/admin/') || path.startsWith('/claim') || path.includes('/broker/')) return true;
    return hiddenRoutes.includes(path);
  }
}
